// Styles 
import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
// Inputs
import { CheckboxInput, ListboxInput } from "components/table/carousel/inputs"
import { field_attrs } from "components/table/lib/column-field"
import { alphanum } from "components/table/lib/sort"
import { ShowSelected_s } from "components/user-admin/user-styles"
import usersService from "data/user"
import _ from "lodash"
import React, { useEffect, useState } from "react"
import { ListboxHeaderSort_s, ListboxSection_s, SelectAllCheckbox_s } from "styles/input-styles"


const Users = (props: {rowData: [], defaults: object, field: string, namedItems: {}, persist: Function}) => {
  const [sortDirty, setSortDirty] = useState<boolean>(false);
  const [sortAsc, setSortAsc] = useState<boolean>(true);
  const [users, setUsers] = useState<object[]>([])
  const [allUsers, setAllUsers] = useState<object[]>([])
  const [data, setData] = useState<number[]|null>(props.rowData[props.field] || []);
  const [showSelected, setShowSelected] = useState<boolean>(props.rowData[props.field].length > 0);

  useEffect(() => {
    const usersSubscription = usersService.stream().subscribe(data => {
      let users = data['users'].map(user => { return user });
      setAllUsers(users);
      if (props.rowData[props.field].length > 0){
        setUsers(users?.filter(user => props.rowData[props.field].includes(user['userid'])).sort((a, b) => alphanum(_.get(a, "name"), _.get(b, "name"))));
      } else {
        setUsers(users.sort((a, b) => alphanum(_.get(a, "name"), _.get(b, "name"))));
      }
    })

    return function cleanup() {
      usersSubscription.unsubscribe()
    }
  }, [])

  useEffect(() => {
    usersService.getUsers()
  }, [])

  useEffect(() => {
    if (showSelected && data){
      setUsers(users?.filter(user => data.includes(user['userid'])));
    } else {
      setUsers(allUsers);
    }
  }, [showSelected, data])

  const updateData = (val:number[]) => {
    setData(val);
    props.persist(val, 'users', props.rowData);
    if (val.length === 0){
      setShowSelected(false)
    }
  }

  const attrs = (field) => field_attrs('users')(field)(props.rowData, props)

  function selectAll():void {
    data?.length === users.length ? updateData([]) : updateData(users.map(user => user['userid']))
  }

  if (sortDirty){
    sortAsc ? users.sort((a, b) => alphanum(a['name'], b['name'])) : users.sort((a, b) => alphanum(b['name'], a['name']))
  }
  
  return (
    <div>
      <SingleRowCarouselState_s>
        <ShowSelected_s>
          <label>Show Selected</label>
          <CheckboxInput className="automated" data={{showSelected}} field='showSelected' persist={(val, field) => setShowSelected(val)} /> 
        </ShowSelected_s>
        <ListboxSection_s>
          <ListboxHeaderSort_s>
            <label>Users</label>
            <a onClick={(e) => { sortDirty === false ? setSortDirty(true) : setSortAsc(!sortAsc)}}>
              { !sortDirty && <i className="pi pi-sort-alt" style={{height: '18px', width: '18px'}} /> }
              { sortDirty && sortAsc && <i className="pi pi-sort-amount-down" style={{height: '18px', width: '18px'}} /> }
              { sortDirty && !sortAsc && <i className="pi pi-sort-amount-up" style={{height: '18px', width: '18px'}} /> }
            </a>
          </ListboxHeaderSort_s>
          <SelectAllCheckbox_s className="automated" data={{allSelected: data ? data.length > 0 && data.length === users.length : false}} field='allSelected' persist={selectAll} />
          <ListboxInput
            className="automated"
            data={{"items": data}}
            attrs={attrs}
            field="items"
            multiple={true}
            persist={updateData}
            options={users.map(user => { return {label: `${user['name']} - ${user['email']}`, value: user['userid']}})}
          />
        </ListboxSection_s>
      </SingleRowCarouselState_s>
    </div>
  )
}

export default Users
